import '@atlassian/jira-vendor/src/vendor-parcel.tsx';
import '@atlassian/jira-vendor/src/commons-parcel.tsx';
// put stability before issue-view route to let it hook before Redux
import './bootstrap/inject-dev-stability-render.tsx';

import { browseIssueEmbedRouteEntry } from '@atlassian/jira-router-routes-issue-entries/src/browseIssueEmbedRouteEntry.tsx';
import { browseIssueRouteEntry } from '@atlassian/jira-router-routes-issue-entries/src/browseIssueRouteEntry.tsx';
import { legacyRedirectRouteEntry } from '@atlassian/jira-router-routes-legacy-redirect-entries/src/legacyRedirectRouteEntry.tsx';
import { workItemRouteEntry } from '@atlassian/jira-router-routes-work-items-entries/src/workItemRouteEntry.tsx';

import { bootstrapSingleSpaRoute } from './bootstrap/single-spa-route.tsx';

bootstrapSingleSpaRoute(() => [
	browseIssueEmbedRouteEntry,
	browseIssueRouteEntry,
	legacyRedirectRouteEntry,
	workItemRouteEntry,
]);
